'use client';
import { ROUTES } from '@/utils/constants';
import { resolveHomePageUrl } from '@/utils/navigation/homePage';
import { hasSsoTokensInHash } from '@/utils/ssoTokenLanding';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Loader } from '@/components/common';

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const { isAuthenticated, user, needsPasswordSetup } = useAuth();
  const router = useRouter();

  useEffect(() => {
    const checkAuthAndRedirect = () => {
      const hash = window.location.hash;

      // If there are SSO tokens in the hash, let SSOTokenHandler process them
      if (hasSsoTokensInHash(hash)) {
        // SSOTokenHandler will handle this
        return;
      }

      // An invite or signup link signs the user in before any password exists, so
      // send them to set one instead of opening the app.
      if (isAuthenticated && needsPasswordSetup) {
        router.push(ROUTES.CHANGE_PASSWORD);
        return;
      }

      // If already authenticated, go to the user's home page
      if (isAuthenticated) {
        router.push(resolveHomePageUrl(user?.homePageUrl));
        return;
      }

      // No tokens and not authenticated, go to signin
      setIsLoading(false);
      router.push(ROUTES.SIGNIN);
    };

    checkAuthAndRedirect();
  }, [isAuthenticated, needsPasswordSetup, user?.homePageUrl, router]);

  if (isLoading) {
    return (
      <div
        className="flex items-center justify-center w-full h-full"
        data-testid="protected-page-wrapper-suspense-fallback"
      >
        <Loader size={10} />
      </div>
    );
  }

  return null;
}
